import { useContext } from 'react';

import { MessageContainerContext } from '../contexts/MessageContainerContext.js';

/** @internal */
export const useMessageContainerContext = () =>
  useContext(MessageContainerContext);
